/**
* @ngdoc directive
* @name Panels
*
* @description
  Show custom panels list
  Used in analytics, accounting home pages
*
* @scope
* @param {Array} panels - with
*  name - panel name
*  description - description
*  href - ui sref
*
* @example
  <panels
    panels="[{ name: 'I am panel', description: 'I am description. Got it?', href: '' }, { name: 'I am second panel', description: 'I am second description. Yep?', href: '' }]">
  </panels>
*/

'use strict';

directive.$inject = ["PATH"];
app.directive('panels', directive);

function directive(PATH) {
  return {
    scope: {
      panels: '=',
      redirect: '&'
    },
    restrict: 'E',
    templateUrl: PATH.components + 'panels/template.html'
  };
}



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/panels/directive.js